import type { SupportedLocale } from "./locale.js";
import { messagesEn } from "./locales/en.js";
import { messagesRu } from "./locales/ru.js";
import { messagesUk } from "./locales/uk.js";

export type AppMessages = typeof messagesUk;

const catalogs: Record<SupportedLocale, typeof messagesUk> = {
  uk: messagesUk,
  ru: messagesRu as unknown as typeof messagesUk,
  en: messagesEn as unknown as typeof messagesUk,
};

export function getMessages(locale: SupportedLocale): AppMessages {
  return catalogs[locale] ?? catalogs.uk;
}

/** @deprecated Prefer useMessages() inside LocaleProvider */
export const messages = messagesUk;

export type SortOrder = "default" | "price_asc" | "price_desc" | "name";

export function segmentLabel(
  segment: string | null | undefined,
  locale: SupportedLocale = "uk",
): string | null {
  if (!segment) return null;
  const messages = getMessages(locale);
  const key = segment as keyof typeof messages.segment;
  return messages.segment[key] ?? segment;
}
